enum SiteConst {
  GOLF_CLUB_VALUE,
  HOTEL_PODO_VALUE,
  HOTEL_ANNEX_VALUE,
  DINING_VALUE,
  PLEISURE_VALUE,
  BIOTOPIA_VALUE,
  __LENGTH,
}

export default SiteConst;
